import React from 'react'
import EuropeanFlag from '../../../images/flag_yellow_low.jpg'

export const EuropeanInfo = props => {
    let text = `This project has received funding from the European Union’s Horizon 2020 research and innovation programme \n under sub-grant agreement
                        No 732947-009`;
    return(
        <div className='row europeanInfo'>
            <div className='class="col-xs-1 specs-description'>
                <img src={EuropeanFlag} width={'100px'} alt='EuropeanFlag' />
            </div>
            <div className='col-xs-5 specs-description'>
                <p>{text}</p>
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/Route/IdentityManager/EuropeanInfo.js